import { IAPIResponseError } from '@literax/models/http/api/error.model';
import { IRolResponse } from '@literax/models/rol.model';

export interface IRolState {
  roles: IRolResponse[];
  rolesError: IAPIResponseError;
}

export const initialRolState: IRolState = {
  roles: [],
  rolesError: null
};
